import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useSelector } from "react-redux";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
} from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Edit } from "@mui/icons-material";
import CustomTable from "../components/data-table/CustomDataTable";
import DistributorForm from "../sections/@dashboard/distributor/distributor.form";

import {
  useGetDistributorsQuery,
  useLazyGetDistributorsQuery,
} from "../redux/services/authUser.service";
// components
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
// sections
import Protected from "../protected/Protected";
import { selectAbility } from "../redux/slices/casl.slice";
import { selectUser } from "../redux/slices/auth.slice";
import useDownloadAll from "../hooks/useDownloadAll";

export default function DistributorPage() {
  const ability = useSelector(selectAbility);

  const user = useSelector(selectUser);

  const { handleDownloadAll, isDownloading } = useDownloadAll(
    useLazyGetDistributorsQuery,
    "Distributors",
  );

  const [openDistributorForm, setOpenDistributorForm] = useState(false);

  const [edit, setEdit] = useState(false);

  const [openRow, setOpenRow] = useState({});

  const handleCloseForm = () => {
    setOpenDistributorForm(false);
    setEdit(false);
    setOpenRow(null);
  };

  return (
    <Protected>
      <Helmet>
        <title> Distributor </title>
      </Helmet>

      <Container>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          spacing={2}
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Distributors
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            alignItems={{ xs: "stretch", sm: "center" }}
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            <Button
              variant="outlined"
              startIcon={
                isDownloading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Iconify icon="eva:download-fill" />
                )
              }
              onClick={() => handleDownloadAll()}
              disabled={isDownloading}
            >
              Download All
            </Button>
            {ability.can("post", "Distributor") && (
              <Button
                variant="contained"
                onClick={setOpenDistributorForm}
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                New Distributor
              </Button>
            )}
          </Stack>
          {(ability.can("patch", "Distributor") ||
            ability.can("post", "Distributor")) && (
            <DistributorForm
              open={openDistributorForm}
              onClose={handleCloseForm}
              edit={edit}
              openRow={openRow}
            />
          )}
        </Stack>

        <Card>
          <Scrollbar>
            <CustomTable
              canSelect
              useDataQuery={useGetDistributorsQuery}
              tableName="Distributors"
              searchLabel="Search Distributor..."
              searchCols={["name", "email", "contactNumber"]}
              actions={
                ability.can("patch", "Distributor")
                  ? {
                      field: "actions",
                      headerName: "Actions",
                      type: "actions",
                      getActions: ({ row }) =>
                        [
                          ability.can("patch", "Distributor") &&
                          (ability.can("Is", "admin") ||
                            row?.parentDistributorId === user?.id) ? (
                            <GridActionsCellItem
                              key="edit"
                              icon={<Edit />}
                              label="Edit"
                              showInMenu
                              onClick={() => {
                                setOpenRow(row);
                                setEdit(true);
                                setOpenDistributorForm(true);
                              }}
                            />
                          ) : null,
                        ].filter((action) => action !== null),
                    }
                  : null
              }
            />
          </Scrollbar>
        </Card>
      </Container>
    </Protected>
  );
}